import IdentityService from '@/services/identity';
import { setGtmUserId } from '@/helpers/gtm';

IdentityService.initIdentity();

setGtmUserId(IdentityService.getTempUserId() as string);
